import { DepartmentResponse } from '../../companies/types';

import apiClient from '@/axios/app-client';
import { FunctionName, PermissionAction } from '@/lib/enums';

// API endpoint constant
const DEPARTMENTS_ENDPOINT = '/v1/departments';

export const departmentsService = {
  getDepartments: async (functionName: FunctionName, permissionAction?: PermissionAction) => {
    const response = await apiClient.get<DepartmentResponse[]>(DEPARTMENTS_ENDPOINT, {
      functionName,
      permissionAction,
    });
    return response.data.data;
  },
};
